import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import { useParams } from "react-router-dom";
import Logo from "../assets/infraLogo.jpg"

const API_BASE =
  import.meta.env?.VITE_API_BASE ||
  process.env.REACT_APP_API_BASE ||
  "https://rfs2.infraconsoft.net.in/api";

const API_ORIGIN = API_BASE.replace(/\/api\/?$/, "");

const StnPrint = () => {
  const handlePrint = () => {
    window.print();
  };

  const {stnNo} = useParams();
  const branch = localStorage.getItem("branch");
  const [header, setHeader] = useState({});
  const [data, setData] = useState([]);

         const [site, setSite] = useState({
    ok: true,
    name: "Infraconsoft",
    logo: null,
    address: "",
    email: "",
    phone: "",
    _ts: 0,
  });

  // Fetch site/company info
  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        const res = await axios.get(`${API_BASE}/siteinfo`);
        const s = res?.data || {};
        // ensure absolute logo URL if server ever returns relative
        let logo = s.logo || null;
        if (logo && !/^https?:\/\//i.test(logo)) {
          if (!logo.startsWith("/")) logo = `/${logo}`;
          logo = `${API_ORIGIN}${logo}`;
        }
        if (!ignore) {
          setSite({
            ok: !!s.ok,
            name: s.name || "Infraconsoft",
            logo,
            address: s.address || "",
            email: s.email || "",
            phone: s.phone || "",
            _ts: Date.now(),
          });
        }
      } catch (e) {
        // keep defaults on failure
        console.error("Failed to load /siteinfo", e);
      }
    })();
    return () => {
      ignore = true;
    };
  }, []);


  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/stnOutwardPrint_detailsHeader?stnNo=${stnNo}&branch=${branch}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
                stnNumber: items[0].sfIssuesHeader_number || "N/A",
                // branch: items[0].branchCode || "N/A",
                stnDate: items[0].sfIssuesHeader_date || "N/A",
                fromBranch: items[0].branchCode || "N/A",
                toBranch: items[0].sfIssuesHeader_branchcode || "N/A",
            };

            setHeader(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails();
  }, [stnNo, branch]); 

  useEffect(() => {
    axios
      .get(`https://rfs2.infraconsoft.net.in/api/stnOutward_listData?stnNo=${stnNo}&branch=${branch}`)
      .then((response) => {
        setData(response.data.bottomDetails);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [stnNo, branch]);

  const logoSrc = site.logo ? `${site.logo}${site._ts ? `?v=${site._ts}` : ""}` : Logo;


  return (
    <div className="dc-print-container">
      {/* Header */}
     <div className="prPrint-header">
        <img src={logoSrc} alt={`${site.name} Logo`} className="prPrint-logo" />
        <div className="prPrint-company-details">
          <h2 style={{ textTransform: "uppercase" }}>{site.name || "Infraconsoft"}</h2>
          {site.address && <p>{site.address}</p>}
          {(site.phone || site.email) && (
            <p>
              {site.phone && <span>Ph: {site.phone}</span>}
              {site.phone && site.email && <span> | </span>}
              {site.email && <span>Email: {site.email}</span>}
            </p>
          )}
        </div>
      </div>

      {/* DC Info */}
      <div className="dc-info">
        <span><strong>STN No:</strong> {header.stnNumber}</span>
        <span><strong>Type:</strong> OutWard</span>
        <span><strong>STN Date:</strong> {header.stnDate ? new Date(header.stnDate).toISOString().split("T")[0] : ""}</span>
      </div>

      {/* From & To Section */}
      <div className="dc-from-to">
        <div className="dc-from">
          <h3>Project Site :</h3>
          <p>{header.fromBranch}</p>
        </div>
        <div className="dc-to">
          <h3>To Site:</h3>
          <p>{header.toBranch}</p>
        </div>
      </div>

      {/* Table */}
      <table className="dc-table">
        <thead>
          <tr>
            <th className="dc-th">S.NO</th>
            <th className="dc-th">Item Code</th>
            <th className="dc-th">Item Name</th>
            <th className="dc-th">Uom</th>
            <th className="dc-th">Quantity</th>
            <th className="dc-th">Price</th>
            <th className="dc-th">Value</th>
          </tr>
        </thead>
        <tbody>
                  {data.length > 0 ? (
                    <>
                      {data.map((item, index) => {
                        const value = item.sfIssuesDetail_price * item.sfissuesDetail_issuedQuantity;
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.sfissuesDetail_itemCode}</td>
                            <td>{item.itemmaster_name}</td>
                            <td>{item.itemmaster_uom}</td>
                            <td>{item.sfissuesDetail_issuedQuantity}</td>
                            <td>{item.sfIssuesDetail_price}</td>
                            <td>{value.toFixed(2)}</td>
                
                          </tr>
                        );
                      })}
                      <tr>
                        <td colSpan={6}><strong>Total Transfer Value</strong></td>
                        <td>
                          <strong>
                            {data
                              .reduce((acc, item) => acc + item.sfIssuesDetail_price * item.sfissuesDetail_issuedQuantity, 0)
                              .toFixed(2)}
                          </strong>
                        </td>
                     
                      </tr>
                    </>
                  ) : (
                    <tr>
                      <td colSpan="9">No items</td>
                    </tr>
                  )}
                </tbody>
      </table>

    

      {/* Signature Section */}
      <div className="dc-signature">
        <span>Transferer</span>
        <span>Site in Charge</span>	
        <span>Transferee</span>				
        <span>Posted by</span>	
        <span>Head Office</span>	
      </div>

      {/* Print Button */}
      <button className="dc-print-button" onClick={handlePrint}>Print</button>
    </div>
  );
};

export default StnPrint;
